import { useEffect, useState } from "react";
import { useQuestionizerStore } from "../types/state.ts";
import { FDWAntragsteller, FDWResultEntry } from "restfd2";
import Checkbox from "./checkbox.tsx";
import LoadingIndicator from "./loading-indicator.tsx";
import Input from "./input.tsx";
import { DoiForm, LeadForm } from "./lead_form.tsx";

export function QuestionizerResultItem(props:{entry:FDWResultEntry}){
    const include_in_print = useQuestionizerStore((state) => state.include_in_print);
    const setIncludeInPrint = useQuestionizerStore((state) => state.setIncludeInPrint);
    //const setIncludeInPrintExclusive = useQuestionizerStore((state) => state.setIncludeInPrintExclusive);
    const config = useQuestionizerStore((state) => state.config);

    const openPrintView = useQuestionizerStore((state) => state.openPrintView);
    const L = useQuestionizerStore((state) => state.L);

    const show_single_item_actions = config?.show_single_item_actions !== false;

    return (<div className="result-item flex flex-row items-start mb-4 cursor-pointer">
              {show_single_item_actions && <Checkbox  labelledby={"checkbox-"+props.entry.fp_id} value={include_in_print[props.entry.fp_id]} onChange={(value)=>{setIncludeInPrint(props.entry.fp_id, value)}}/>}
              <label id={"checkbox-"+props.entry.fp_id} className="mr-4 flex flex-col items-start">
                <span className="result-item__name font-bold">{props.entry.fp_name}</span>
                <span className="result-item__betrag">{props.entry.fp_betrag}</span>
              </label>
              {show_single_item_actions && 
                <button tabIndex={0} aria-label="Als PDF-Dokument anzeigen" className={"result-item__print"} 
                onClick={(_)=>{
                  openPrintView(props.entry.fp_id);
                }}
                onKeyUp={(event)=>{
                  if(event.code != "Enter" && event.code != " "){return;}
                  openPrintView(props.entry.fp_id);
                }}
                >
                <span aria-hidden className="result-item__print_label">{L('Anzeigen') || 'Anzeigen'}</span><div className={"icon icon-print result-item__icon_print"}></div>
              </button>}
          </div>);  
  }